import { cn } from '@/lib/utils'

export function LogoMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} className={cn('shrink-0', className)} aria-hidden>
      <rect width="32" height="32" rx="9" fill="var(--brand-strong)" />
      {/* cat ears + face outline forming a "D" */}
      <path d="M9 12 L10.5 6.5 L14 10 M23 12 L21.5 6.5 L18 10" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M8.5 17c0-4.2 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5-3.4 7.5-7.5 7.5-7.5-3.3-7.5-7.5Z" stroke="#fff" strokeWidth="2" fill="none" />
      <circle cx="13" cy="16.5" r="1.3" fill="#fff" />
      <circle cx="19" cy="16.5" r="1.3" fill="#fff" />
      <path d="M14.5 20c.9.8 2.1.8 3 0" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" fill="none" />
    </svg>
  )
}

export function Logo({ collapsed }: { collapsed?: boolean }) {
  return (
    <div className="flex items-center gap-2.5">
      <LogoMark />
      {!collapsed && (
        <div className="leading-tight">
          <div className="text-[15px] font-semibold tracking-tight text-ink-strong">Dovira</div>
          <div className="text-[11px] font-medium uppercase tracking-[0.08em] text-muted">AI Bridge</div>
        </div>
      )}
    </div>
  )
}
